import { $ } from "@/common/Axios";

export default {
  /**
   * 提问
   */
  question_batchUpdateStatus: {
    /*
     * 批量修改解决状态
     * ids ids (array query required)
     * status 解决状态 (string query required)
     */
    put: (p, c) => $.put("/api/sms/social/question/batchUpdateStatus", p, c),
  },
  question: {
    /*
     * 添加
     * question  ( query required)
     */
    post: (p, c) => $.post("/api/sms/social/question", p, c),
  },
  question_answer: {
    /*
     * 回复
     * id id (integer query required)
     * answer 提问内容 (string query required)
     * status 解决状态 (string query )
     */
    post: (p, c) => $.post("/api/sms/social/question/answer", p, c),
  },
  question_testAdminCreateTime: {
    /*
     * C端直播提问列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/sms/social/question/testAdminCreateTime", p, c),
  },
  question_listAdultExamSubjectQuestion: {
    /*
     * 成考习题反馈列表
     */
    get: (p, c) =>
      $.get("/api/sms/social/question/listAdultExamSubjectQuestion", p, c),
  },
  question_listAdultExamLiveCourseQuestion: {
    /*
     * 成考直播提问列表
     */
    get: (p, c) =>
      $.get("/api/sms/social/question/listAdultExamLiveCourseQuestion", p, c),
  },
  question_listAdultExamLiveCourseQuestionForClient: {
    /*
     * C端直播提问列表
     * liveCourseChapterId 直播章节id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/sms/social/question/listAdultExamLiveCourseQuestionForClient",
        p,
        c
      ),
  },
};
